import axios from 'axios';
import { BASE_URL } from '../utils/constants';

//attemt_id is a variable with a set function

interface TestResult {
  passed: boolean;
  message?: string;
}

interface ParsedTestResult {
  consoleOutput: string;
  testResults: TestResult[];
}

interface ExecuteCodeResult {
  attempt_id: number;
  consoleOutput: string;
  testResults: TestResult[];
}

const parseTestResults = (result: any): ParsedTestResult => {
  let consoleOutput = '';
  let testResults: TestResult[] = [];

  const tests = result.test_results?.tests;

  // Handle case where no test results are available
  if (!result.test_results) {
    const output_txt = result.console_output.split("\n");
    const last_three_lines = output_txt.slice(-4)
      .map((line: string) => line.replace("E   ", ""))
      .join("\n");
    return {
      consoleOutput: ">" + (last_three_lines || output_txt),
      testResults: []
    };
  }

  if (!Array.isArray(tests) || tests.length === 0) {
    const output_txt = result.console_output.split("\n")
      .filter((line: string) => line.startsWith("E   "))
      .map((line: string) => line.replace("E   ", ""));
    const last_three_lines = output_txt.slice(-3).join("\n");
    return {
      consoleOutput: ">ERROR: " + (last_three_lines || output_txt),
      testResults: []
    };
  }

  // Parse test results
  testResults = tests.map((test: any) => ({
    passed: test.call.outcome === 'passed'
  }));

  console.log("tests:", tests);

  // Find first failed test for detailed error message
  const firstFailedTest = tests.find((test: any) => test.call.outcome !== 'passed');
  if (firstFailedTest) {
    const error = firstFailedTest.call.longrepr.split("\n");
    console.log("Error:", error);
    let error_msg = error.find((line: string) => 
      line.includes("E   assert") || line.includes("E   AssertionError: assert")
    );

    if (error_msg) {
      // ... existing error parsing logic ...
      const error_type = "AssertionError";
      let output_txt = error_msg.split("==")[1] || error_msg;
      
      let actual_output = error_msg.includes("E   assert") 
        ? error_msg.split("E   assert")[1].split("==")[0]
        : error_msg.split("E   AssertionError: assert")[1]?.split("==")[0] || error_msg;

        var input_txt = error.filter((line: string) => !line.includes("E   ") && !line.includes("AssertionError: assert") && !line.includes("tmp/") && !line.includes("where")).map((line: string) => line.trim())
        console.log("Input txt:", input_txt);
        var final_input_txt = []
        if (input_txt){
          if (input_txt.length > 0) {
            
            var append = true

            for (var line of input_txt) {
              if (line.includes("=")){
                if (line.includes("expected") || line.includes("output") || line.includes("result")) {
                  append = false
                }
                else {
                  append = true
                }
              }
              if (!append) {
                continue
              }
              else {
                if (line.includes("assert")) {
                  final_input_txt.push('\n' + line.replace("assert", "").split("==")[0])
                }
                else if (line.includes("object at")) {
                  continue
                }
                else {
                  final_input_txt.push('\n' + line)
                }
              }
            }
            
          }
            
        }
        else {
          final_input_txt = input_txt[0].replace("assert", "")
        }
        final_input_txt = final_input_txt.join(" ")
        console.log("--Input txt:", final_input_txt);
      
      consoleOutput = ">ERROR: "+error_type + "\n\n" + ">INPUT: " + final_input_txt + "\n\n" + ">EXPECTED OUTPUT: " + output_txt + "\n\n" + ">ACTUAL OUTPUT: " + actual_output;
    } else {
      const first_line_with_E = error.find((line: string) => line.startsWith("E   "));
      consoleOutput = ">ERROR: " + first_line_with_E?.replace("E   ", "");
    }
  } else {
    consoleOutput = 'All tests passed successfully!';
  }

  return { consoleOutput, testResults };
};

export const ExecuteCode = {
  execute: async (user_id: number, session_id: string, problem_id: number, code: string, test_suite: string): Promise<ExecuteCodeResult> => {
    try {
      const response = await axios.post(`${BASE_URL}/attempt/`, {
        user_id,
        session_id,
        problem_id,
        student_code: code,
        test_suite
      });

      const parsedResults = parseTestResults({
        test_results: response.data.test_results,
        console_output: response.data.console_output
      });

      return {
        attempt_id: response.data.id,
        consoleOutput: parsedResults.consoleOutput,
        testResults: parsedResults.testResults
      };
    } catch (error) {
      console.error('Error executing code:', error);
      throw error;
    }
  }
};